import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

const IndicatorCard = ({
  title,
  value,
  change,
  Icon,
  filterKey,
  iconBgColor = "#E8F0FE",
  iconColor = "#0D6EFD",
  programaId,
}) => {
  const navigate = useNavigate();
  const isPositive = change >= 0;
  const changeColor = isPositive ? "text-success" : "text-danger";
  const changeSign = isPositive ? "+" : "";
  const changeValue = change || 0;

  const cardPage = localStorage.getItem(`programa_ocultar_atendimentos_${programaId}`) === 'sim' ? 'atendimentos-receptivo' : 'atendimentos';

  return (
    <Card
      onClick={() => navigate(`/${cardPage}?indicador=${filterKey}`)}
      className="shadow-sm border-0 h-100 w-100" 
      style={{
        borderRadius: "16px",
        cursor: "pointer",
        transition: "transform 0.2s, box-shadow 0.2s",
        background: "#fff",
        minHeight: "140px", 
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-5px)";
        e.currentTarget.style.boxShadow = "0 10px 20px rgba(0,0,0,0.1)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      <Card.Body className="d-flex flex-column justify-content-between p-4">
        
        {/* Cabeçalho */}
        <div className="d-flex justify-content-between align-items-start mb-3">
          <h6
            className="fw-bold mb-0"
            style={{
              fontSize: "0.9rem",
              lineHeight: "1.4",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
            title={title}
          >
            {title.toUpperCase()}
          </h6>
          <div
            className="rounded-circle d-flex justify-content-center align-items-center"
            style={{
              width: "36px",
              height: "36px",
              minWidth: "36px",
              backgroundColor: iconBgColor,
              color: iconColor,
            }}
          >
            {Icon && <Icon size={20} />}
          </div>
        </div>

        {/* Valor */}
        <div>
          <h2 className="fw-bold mb-1" style={{ fontSize: "2rem", color: "#333" }}>
            {value}
          </h2>
          <small className="text-muted fw-medium" style={{ fontSize: "0.8rem" }}>
            {changeValue !== 0 ? (
              <>
                <span className={changeColor}>
                  {changeSign}{changeValue}%
                </span>{" "}
                vs. 30 dias
              </>
            ) : (
              <span>&nbsp;</span>
            )}
          </small>
        </div>
      </Card.Body>
    </Card>
  );
};

IndicatorCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  change: PropTypes.number,
  filterKey: PropTypes.string.isRequired,
  Icon: PropTypes.func,
  iconBgColor: PropTypes.string,
  iconColor: PropTypes.string,
  programaId: PropTypes.string,
};

export default IndicatorCard;
